module.exports = __webpack_public_path__ + "static/media/gsb.635831cf.png";